import { useGlobalSearchParams } from 'expo-router'
import { Stack } from 'expo-router/stack'
import React, { useEffect, useReducer } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from '~redux'
import { actions, initialState, NewChatContext, reducer } from './state'

export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default function Layout() {
  const { folderId, folderName, templateId } = useGlobalSearchParams<{
    folderId?: string
    folderName?: string
    templateId?: string
  }>()
  const template = useSelector((state: ApplicationState) => state.chat.template)

  const getInitialState = () => {
    const state = { ...initialState }
    if (typeof folderId === 'string') {
      state.class = {
        id: folderId,
        name: '',
      }
      state.dismissTo = !state.showFolderSelection ? `/folders/${state.class.id}` : `/`
    } else {
      state.showFolderSelection = true
    }
    if (templateId && template && template?.id === templateId) {
      state.name = template.name ?? ''
      state.template = template
    }
    return state
  }

  const [state, dispatch] = useReducer(reducer, getInitialState())

  useEffect(() => {
    if (folderId && folderId !== state.class.id) {
      dispatch(actions.setClassId({ id: folderId, name: folderName ?? '' }))
      dispatch(actions.setDismissTo(`/folders/${folderId}`))
    }
  }, [folderId, folderName, state.class.id, dispatch])

  return (
    <NewChatContext.Provider value={[state, dispatch]}>
      <Stack initialRouteName="index">
        <Stack.Screen name="index" options={{ title: 'New Chat' }} />
        <Stack.Screen name="details" options={{ title: 'Details' }} />
        <Stack.Screen name="empty" options={{ title: 'Empty chat layout' }} />
        <Stack.Screen name="folder" options={{ title: 'Location' }} />

        {/* Community */}
        <Stack.Screen name="community/index" options={{ title: 'Community chat template' }} />
        <Stack.Screen
          name="community/category/[categoryId]/index"
          options={{ title: 'Community chat template' }}
        />
        <Stack.Screen
          name="community/template/[templateId]/index"
          options={{ title: 'Community chat template' }}
        />
        <Stack.Screen
          name="community/template/[templateId]/report"
          options={{ title: 'Report Chat' }}
        />

        {/* School */}
        <Stack.Screen name="school/index" options={{ title: 'School chat template' }} />
        <Stack.Screen name="school/tag/[slug]/index" options={{ title: 'School chat template' }} />
        <Stack.Screen
          name="school/template/[templateId]/index"
          options={{ title: 'School chat template' }}
        />
        <Stack.Screen
          name="school/template/[templateId]/report"
          options={{ title: 'Report Chat' }}
        />
      </Stack>
    </NewChatContext.Provider>
  )
}
